/**
 * StockModuleGuard - Bloqueia rotas do Estoque quando o módulo está desligado
 *
 * A proteção real está nas RPCs (`_stock_assert_permission`); este guard só
 * evita exibir telas vazias e redireciona para o início.
 *
 * RELEASE: 2026-10-06 v1.0.0 - Criação inicial (Fase 2 do Estoque).
 */
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import { useStockModule } from '@/hooks/useStockModule';

export function StockModuleGuard({ children }: { children: ReactNode }) {
  const { isEnabled, isLoading } = useStockModule();
  if (isLoading) return <Skeleton className="m-6 h-40 rounded-lg" />;
  if (!isEnabled) return <Navigate to="/tenant/chat" replace />;
  return <>{children}</>;
}
